import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import Brand from './Brand';

export default function Footer({ t }) {
  const f = t.footer;

  return (
    <footer className="bg-paper border-t border-line">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <p className="text-xs text-stone leading-relaxed max-w-5xl">{f.blurb}</p>

        <div className="mt-12 grid md:grid-cols-3 gap-10 items-start">
          <div className="flex flex-col gap-4">
            <Brand />
            <p className="text-xs text-stone">{f.copyright}</p>
          </div>

          <nav className="flex flex-col gap-3">
            {f.links.map((link) => (
              <a key={link.label} href={link.href} className="text-sm font-semibold hover:text-ember transition-colors">
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <span className="font-display text-sm tracking-[0.22em] uppercase">{f.contactTitle}</span>
            <a href={`mailto:${f.email}`} className="inline-flex items-center gap-2 text-sm hover:text-ember">
              <Mail size={15} className="text-ember" />
              {f.email}
            </a>
            <p className="inline-flex items-start gap-2 text-sm text-stone">
              <MapPin size={15} className="text-ember shrink-0 mt-0.5" />
              <span>
                {f.company}
                <br />
                {f.address}
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
